<template>
  <b-card
    class="queue-section mb-5"
    :border-variant="variant"
    :header-bg-variant="variant"
    header-text-variant="white"
    header-class="p-3 font-size-lg font-weight-bold d-flex justify-content-between align-items-center"
    body-class="p-0"
  >
    <template #header>
      <span>{{ status }}</span>
      <b-badge variant="light" class="font-weight-bolder">{{ items.length }}</b-badge>
    </template>

    <WorkItemRow
      v-for="item in items"
      :key="item.id"
      :item="item"
      @action="$emit('action', $event)"
    />
  </b-card>
</template>

<script>
import WorkItemRow from "./WorkItemRow.vue";

export default {
  name: "QueueSection",

  components: { WorkItemRow },

  props: {
    status: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    variant: {
      type: String,
      default: "primary"
    }
  }
};
</script>
